/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import styled from 'styled-components'

/**********************************************************************************************************
 *   INTERFACE
 **********************************************************************************************************/
interface Props {
    eligibilityFields: object[]
}

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function EligibilityRequirement({ eligibilityFields }: Props) {
    return eligibilityFields.length >= 1 ? <Toggle>Yes</Toggle> : null
}

/**********************************************************************************************************
 *   CUSTOM STYLING
 **********************************************************************************************************/
const Toggle = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`
